// import axios from 'axios';

// export default axios.create({
//   baseURL: `http://172.28.1.155:7000`
// });

import axios from "axios";
// axios.defaults.withCredentials = true;

const api = () => {
  // const history = useHistory();
  // Retrieve the object from storage
var retrievedObject = localStorage.getItem('testObject');

console.log('retrievedObject: ', JSON.parse(retrievedObject));
  const defaultOptions = {
    // baseURL: `http://172.20.35.78:7020/`,
     //baseURL: `http://localhost:7050/`,//eserv-server-build port
   baseURL: `./api`,
    //  baseURL: `http://localhost:7020`,
    // This is the server IP where the program is hosted
    // baseURL: `http://192.168.2.119:7001`,
    // baseURL: process.env.baseURL,

    headers: {
      "Access-Control-Allow-Origin": "http://localhost:3000",
      "invera-charset": "ISO-8859-15",
      "invera-username": "webspl",
      "content-type": "application/json; charset=UTF-8",
      // "invera-service-name": ,
      "invera-session":
        "data:text/plain;base64,NzI3ZmM4YTItMGYxZS00NDY3LTliNzQtOTk5OGJmNjM3ZGIwOl5zY3lBdXRoXndlYnNwbF5VU0FeZW5ebG9jYWxob3N0XjEyNy4wLjAuMV5sb2NhbGhvc3ReMF4yMDE3MTEyNDE1MzAwMDc4NV4gICA=",
    },
  };
  // Create instance
  let instance = axios.create(defaultOptions);

  //   Set the AUTH token for any request
  instance.interceptors.request.use(function (config) {
    
    const token = localStorage.getItem("token");
    const emailtoken = localStorage.getItem("email");
    const usrLgnId = localStorage.getItem("usrLgnId");
    // const detail = localStorage.getItem("detail");

    config.headers.usrLgnId = usrLgnId ? `${usrLgnId}` : "";
    config.headers.token = token ? `${token}` : "";
    // config.headers.accstring = detail ? `${detail}` : "";
    config.headers.email = emailtoken ? `${emailtoken}` : "";

    return config;
  });
  instance.interceptors.response.use(
    function (response) {
      //Dispatch any action on success

      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        const usertype =localStorage.getItem("type")||'I'
         alert("Unauthorise/Session Expire")
         let baseUrl = window.location.pathname.split('/eserv/')[0] || '';
         baseUrl = baseUrl + '/eserv';
         window.location.href = baseUrl + '/login?type=' + usertype;
         //window.location.href = "/login?type="+usertype;
        localStorage.clear();
       
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

// Version API function
export const getVersionInfo = () => {
  return api().get('/api/version');
};

export default api();
